export { DefaultComponent } from './DefaultComponent';
